<template>
  <div :class="classes">
      <template v-if="isTitle">
      <pt-page-title title="新闻列表">
          <template  slot="before-left">
          <el-button type="primary" @click="creatNews">创建新闻</el-button>
          <el-button type="primary" @click="newsClassify">分类管理</el-button>
          </template>
      </pt-page-title>
      <pt-page-factor-filter :labels="newsTabLabels" v-model="params"  isQueryRouter ref="filter" @Filter="filter">
          <el-button type="primary" @click="filter()">筛选</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </pt-page-factor-filter>
      </template>
      <pt-news-table :tableLabels="tableLabels" :params-data="paramsData" ref="table" class="pt-news-manage-table" :isFromRouter="isFromRouter">
            <el-table-column label="推荐值">
                <template  slot-scope="scope">
                    <div :class="$style['ranking-div']" @mouseenter="editRanking(scope.row)"   @mouseleave="noEditRank(scope.row)">
                        {{scope.row.ranking}}
                        <el-popover placement="bottom" trigger="click" v-if="scope.row.isEditRank" @mouseenter="editRanking(scope.row)">
                            <edit-ranking :rowInfo="scope.row" @sumitRank="sumitRank"></edit-ranking>
                            <i class="iconfont icon-bianji"  slot="reference"  @click="editRinkValue(scope.row)"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="首页展示" v-if="isTitle">
                <template slot-scope="scope">
                     <el-switch :value="scope.row.isHomePageVisible" @change="recommendChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="置顶" v-if="isTitle">
                <template slot-scope="scope">
                     <el-switch :value="scope.row.isStick" @change="stickyChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="在工具中心展示" v-if="isTitle">
                <template slot-scope="scope">
                     <el-switch :value="scope.row.toolsCenterVisible" @change="toolsVisibleChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="在活动中心展示" v-if="isTitle">
                <template slot-scope="scope">
                     <el-switch :value="scope.row.actionCenterVisible" @change="actionVisibleChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="新闻状态">
                <template  slot-scope="scope">
                    {{scope.row.news_state}}
                </template>
            </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="detail(scope.row)">详情</el-button>
                <el-button type="text" v-if="scope.row.state=='PUBLISHED'" @click="disabled(scope.row)">下架</el-button>
                <template v-else>
                    <el-button type="text" v-if="scope.row.state=='DRAFT'" @click="publish(scope.row)">发布</el-button>
                    <el-button type="text" @click="editNews(scope.row)">编辑</el-button>
                    <el-button type="text" @click="deleteNews(scope.row)">删除</el-button>
                </template>
              </template>
          </el-table-column>
      </pt-news-table>
  </div>
</template>

<script>
// 组件class前缀
import ptNewsTable from './pt-news-table/withData'
import editRanking from './edit-ranking'
import { newsTabLabels, tableLabels } from './news-option'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-news-manage'
export default {
  name: 'pt-news-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    newsCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    tableParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    ptNewsTable,
    editRanking
  },
  data () {
    return {
      newsTabLabels: newsTabLabels,
      tableLabels: tableLabels,
      params: {},
      paramsData: this.tableParams,
      isFromRouter: false
    }
  },
  watch: {
    newsCategories: {
      handler: function (val) {
        this.newsTabLabels.forEach(item => {
          if (item.value === 'categoryId') {
            item.options = val
          }
        })
      }
    }
  },
  methods: {
    recommendChange (val) {
      let text = val.isHomePageVisible ? '取消该新闻的首页展示' : '将该新闻展示在首页'
      this.$confirm('您是否确定' + text, '首页展示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('goodsRecommend', val)
      })
    },
    stickyChange (val) {
      let text = val.isStick ? '取消置顶该新闻' : '置顶该新闻'
      this.$confirm('您是否确定' + text, '置顶', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        if (val.isStick) {
          this.$emit('cancelStick', val)
        } else {
          this.$emit('setStick', val)
        }
      })
    },
    toolsVisibleChange (val) {
      let text = val.toolsCenterVisible ? '取消在工具中心的展示' : '在工具中心的展示该新闻'
      this.$confirm('您是否确定' + text, '工具中心的展示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('toolsVisibleChange', val)
      })
    },
    actionVisibleChange (val) {
      let text = val.actionCenterVisible ? '取消在活动中心的展示' : '在活动中心的展示该新闻'
      this.$confirm('您是否确定' + text, '活动中心的展示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('actionVisibleChange', val)
      })
    },
    noEditRank (val) {
      if (!val.isedit) {
        this.$set(val, 'isEditRank', false)
      }
    },
    editRanking (val) {
      this.$set(val, 'isEditRank', true)
      val.isEditRank = true
    },
    editRinkValue (val) {
      this.$set(val, 'isedit', true)
      this.$set(val, 'isEditRank', true)
      this.row_now = val
    },
    sumitRank () {
      this.$set(this.row_now, 'isEditRank', false)
      this.getNewsList()
    },
    cleanParams () {
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.filter()
    },
    disabled (val) {
      this.$confirm('您是否确定下架该新闻', '下架提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('disabled', val)
      })
    },
    publish (val) {
      this.$confirm('您是否确定发布该新闻', '发布提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('publish', val)
      })
    },
    getNewsList () {
      let page = this.$refs.table.page
      this.$refs.table.getNewsList(page)
    },
    detail (val) {
      this.$router.push('/news-manage/news-detail/' + val.id)
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'publishDate') {
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
    },
    creatNews () {
      this.$router.push('/news-manage/news-form/0/' + false)
    },
    editNews (val) {
      this.$router.push('/news-manage/news-form/' + val.id + '/' + true)
    },
    deleteNews (val) {
      this.$confirm('您是否确定删除该新闻', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('deleteNews', val.id)
      })
    },
    newsClassify () {
      this.$router.push('/news-manage/news-classify')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less">
.pt-news-manage{
    .pt-news-manage-table{
    .el-button{
        margin-left:0!important;
        margin-right:10px!important;
    }
    }

}
</style>
